module.exports = __webpack_public_path__ + "img/aParty_111223_B.dfd87287.jpg";